import React from 'react';
import { fixMojibake } from '../../../../../utils/text/fix-mojibake';
import { CompanyLogo } from '../../../../../components/CompanyLogo';
import { formatLocationForJobHeaderTitle } from '../utils/job-detail-location-parts';

export interface JobHeaderProps {
  title?: string;
  normalisedTitle?: string | null;
  companyId?: string | null;
  /** Marketing / display name for logo initials when it differs from `companyId`. */
  companyDisplayName?: string | null;
  registryCompanyFormDescription?: string | null;
  location?: string | string[];
  isTyomarkkinatori?: boolean;
}

export const JobHeader: React.FC<JobHeaderProps> = ({
  title,
  normalisedTitle,
  companyId,
  companyDisplayName,
  registryCompanyFormDescription,
  location,
  isTyomarkkinatori = false,
}) => {
  if (!title) return null;

  const locationLine = formatLocationForJobHeaderTitle(location);
  const h1Text = [title, companyId, locationLine].filter(Boolean).join(' - ');

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-start gap-3">
        {companyId ? (
          <div className="flex-shrink-0">
            <CompanyLogo
              companyName={companyId}
              initialsSourceName={companyDisplayName ?? companyId}
              registryCompanyFormDescription={registryCompanyFormDescription}
              size="medium"
              variant="rounded"
              isTyomarkkinatori={isTyomarkkinatori}
              loading="eager"
            />
          </div>
        ) : null}
        <div className="flex-1 min-w-0">
          <h1 className="font-bold text-xl leading-tight text-[#1E1A14] dark:text-[#F2EADF] whitespace-normal break-words">{fixMojibake(h1Text)}</h1>
          {normalisedTitle && normalisedTitle !== title && (
            <h2
              className="text-sm text-[#7A6E5F] dark:text-[#B8A48C] font-normal italic mt-1 whitespace-normal break-words"
              title={fixMojibake(normalisedTitle)}
            >
              {fixMojibake(normalisedTitle)}
            </h2>
          )}
        </div>
      </div>
    </div>
  );
};
